namespace Serenity.Extensions {
    export interface GetNextNumberResponse extends ServiceResponse {
        Number?: number;
        Serial?: string;
    }
}
